import React, { useEffect, useState } from "react";
import { FINANCE_HOSTNAME, REPORT_HOSTNAME } from "../../../../common-utilities/utils/end-points";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { getHeaderConfig } from "./helper";
import MuiTable from "../../../../common-utilities/core/mui-table";
import { FINANCE_REST_URLS } from "../../../../common-utilities/utils/end-points/finance";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import CustomModal from "../../../../common-utilities/core/modal";
import "./index.scss";
import { exportToExcel } from "../../../../common-utilities/utils";
import { isCreateAllowed } from "../../../utils/common-utils";
import ConfirmModal from "../../../../common-utilities/core/confirm-modal";
import { toast } from "react-toastify";
import FileUpload from "../../../../common-utilities/core/file-uploader";
import DownloadTemplateButton from "../common-components/upload-template";
import { uploadTemplates } from "../constants";
import PriceHistory from "./history";
import { UOM_LIST } from "../../purchase-order/helper";
import { clearProperty } from "../../../../common-utilities/utils/misc";
import { formatExcelHeaders } from "./utils";
import { setProperty } from "../../../../common-utilities/utils/misc";
import FAItemsMaster from "../fa-items-master";

const ItemList = ({}) => {
  const [budgetModal, setBudgetModal] = useState(false);
  const [faItemsMasterModal, setFAItemsMasterModal] = useState(false);
  const [selectedFAType, setSelectedFAType] = useState(null);
  const [faItemsList, setFAItemsList] = useState([]);
  const [newFAItemName, setNewFAItemName] = useState("");
  const [formDetails, setFormDetails] = useState({});
  const [budgetList, setBudgetList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subcategoryList, setSubcategoryList] = useState({});
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
  });
  const [inputValue, setInputValue] = useState("");
  const [subCategoryInputValue, setSubCategoryInputValue] = useState("");
  const [deleteDetails, setDeleteDetails] = useState(null);
  const [priceHistoryDetails, setPriceHistoryDetails] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [inputUnitValue, setInputUnitValue] = useState("");
  const [isFAOptions, setIsFAOptions] = useState({
    faClassCode: [],
    faSubClassCode: [],
    depreciationBookCode: [],
    depreciationMethod: [],
    noOfDepreciationYear: [],
    faPostingGroup: [],
  });

  useEffect(() => {
    loadData(filters);
    loadCategory();
  }, []);

  const loadData = (filters) => {
    let params = {
      ...filters,
    };
    if (searchKey) {
      params.searchKey = searchKey;
    }
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_HOSTNAME}${FINANCE_REST_URLS.ITEMS}`,
      null,
      params
    )
      .then((response) => {
        if (response.message) {
        } else {
          if (params?.page > response?.totalPages) {
            setProperty("page", response?.totalPages, setFilters);
          }
          setBudgetList(response || []);
        }
      })
      .catch((err) => {});
  };

  const loadCategory = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_HOSTNAME}${FINANCE_REST_URLS.CATEGORY}`,
      null,
      { limit: 1000, page: 1 }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setCategoryList(
            (response.results || []).map((c) => {
              return { label: c.name, value: c.id, id: c.id };
            })
          );
        }
      })
      .catch((err) => {});
  };

  const loadSubcategory = (categoryId) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_HOSTNAME}${FINANCE_REST_URLS.SUBCATEGORY}`,
      null,
      { limit: 1000, page: 1, category: categoryId }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setSubcategoryList(
            (response.results || []).map((c) => {
              return { label: c.name, value: c.id, id: c.id };
            })
          );
        }
      })
      .catch((err) => {});
  };

  const editVendor = (data, type) => {
    const { category = {}, subCategory = {}, priceHistory = [] } = data;

    if (type === "HISTORY") {
      setPriceHistoryDetails(priceHistory || {});
    } else {
      setBudgetModal(true);
      const uom = UOM_LIST.find((e) => e.value === data.uom) || null;
      setInputUnitValue(uom?.name);

      // Initialize form with FA fields
      setFormDetails(() => ({
        ...data,
        uom,
        isFA: data.fa || false,
        faClassCode: data.faClassCode
          ? { label: data.faClassCode, value: data.faClassCode }
          : null,
        faSubClassCode: data.faSubClassCode
          ? { label: data.faSubClassCode, value: data.faSubClassCode }
          : null,
        depreciationBookCode: data.depreciationBookCode
          ? {
              label: data.depreciationBookCode,
              value: data.depreciationBookCode,
            }
          : null,
        depreciationMethod: data.depreciationMethod
          ? { label: data.depreciationMethod, value: data.depreciationMethod }
          : null,
        noOfDepreciationYear: data.noOfDepreciationYear
          ? {
              label: data.noOfDepreciationYear,
              value: data.noOfDepreciationYear,
            }
          : null,
        faPostingGroup: data.faPostingGroup
          ? {
              label: data.faPostingGroup,
              value: data.faPostingGroup,
            }
          : null,
      }));

      if (category?.id) {
        loadSubcategory(category.id);
        setSubCategoryInputValue(subCategory.name || "");
        setInputValue(category.name || "");
      }
    }
  };

  const downloadData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${REPORT_HOSTNAME}${FINANCE_REST_URLS.ITEMS}`,
      null,
      { page: 1, limit: budgetList.totalResults || 1000 }
    )
      .then((response) => {
        if (response.message) {
        } else {
          exportToExcel(
            formatExcelHeaders(response.results),
            "items-list",
            true
          );
        }
      })
      .catch((err) => {});
  };

  const onDelete = () => {
    invokeApi(
      HTTP_METHODS.DELETE,
      `${FINANCE_HOSTNAME}${FINANCE_REST_URLS.ITEMS}/${deleteDetails.id}`
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response.message, { autoClose: 2000 });
          return;
        }
        loadData(filters);
        setDeleteDetails(null);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (formDetails.isFA) {
      invokeApi(
        HTTP_METHODS.GET,
        `${FINANCE_HOSTNAME}${FINANCE_REST_URLS.FA_ITEMS_MASTER}/1`
      )
        .then((res) => {
          if (res) {
            setIsFAOptions({
              faClassCode:
                res?.faClassCode?.map((e) => ({
                  label: e,
                  value: e,
                })) || [],
              faSubClassCode:
                res?.faSubClassCode?.map((e) => ({
                  label: e,
                  value: e,
                })) || [],
              depreciationBookCode:
                res?.depreciationBookCode?.map((e) => ({
                  label: e,
                  value: e,
                })) || [],
              depreciationMethod:
                res?.depreciationMethod?.map((e) => ({
                  label: e,
                  value: e,
                })) || [],
              noOfDepreciationYear:
                res?.noOfDepreciationYear?.map((e) => ({
                  label: e,
                  value: e,
                })) || [],
              faPostingGroup:
                res?.faPostingGroup?.map((e) => ({
                  label: e,
                  value: e,
                })) || [],
            });
          }
        })
        .catch((err) => {
          toast.error("Failed to load FA options");
        });
    }
  }, [formDetails.isFA]);
  const handleIsFAToggle = (e) => {
    const { checked } = e.target;
    setFormDetails((prev) => ({ ...prev, isFA: checked }));
  };

  const onSave = () => {
    const { category = {}, subCategory = {}, uom = {} } = formDetails;
    let payload = {
      name: formDetails.name,
      price: formDetails.price,
      taxPercentage: formDetails.taxPercentage || 0,
      specification: formDetails.specification,
      hsnCode: formDetails.hsnCode,
      glCode: formDetails.glCode,
      glName: formDetails.glName,
      fa: formDetails.isFA || false,
    };

    if (uom?.value) {
      payload.uom = uom?.value;
    }

    if (category?.id) {
      payload.category = category.id;
    }

    if (subCategory?.id) {
      payload.subCategory = subCategory.id;
    }

    if (formDetails.isFA) {
      if (formDetails.faClassCode?.value) {
        payload.faClassCode = formDetails.faClassCode.value;
      }
      if (formDetails.faSubClassCode?.value) {
        payload.faSubClassCode = formDetails.faSubClassCode.value;
      }
      if (formDetails.depreciationBookCode?.value) {
        payload.depreciationBookCode = formDetails.depreciationBookCode.value;
      }
      if (formDetails.depreciationMethod?.value) {
        payload.depreciationMethod = formDetails.depreciationMethod.value;
      }

      if (formDetails.noOfDepreciationYear?.value) {
        payload.noOfDepreciationYear = formDetails.noOfDepreciationYear.value;
      }
      if (formDetails.faPostingGroup?.value) {
        payload.faPostingGroup = formDetails.faPostingGroup.value;
      }
    }

    invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_HOSTNAME}${FINANCE_REST_URLS.ITEMS}`,
      payload
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message, { autoClose: 2000 });
        } else {
          setBudgetModal(false);
          loadData(filters);
          setFormDetails({});
        }
      })
      .catch((err) => {});
  };

  const onUpdate = () => {
    const { category = {}, subCategory = {}, uom = {} } = formDetails;
    let payload = {
      name: formDetails.name,
      price: formDetails.price,
      taxPercentage: +formDetails.taxPercentage || 0,
      specification: formDetails.specification,
      hsnCode: formDetails.hsnCode,
      glCode: formDetails.glCode,
      glName: formDetails.glName,
      fa: formDetails.isFA || false,
    };

    if (uom?.value) {
      payload.uom = uom?.value;
    }

    if (category?.id) {
      payload.category = category.id;
    }

    if (subCategory?.id) {
      payload.subCategory = subCategory.id;
    }

    if (formDetails.isFA) {
      if (formDetails.faClassCode?.value) {
        payload.faClassCode = formDetails.faClassCode.value;
      }
      if (formDetails.faSubClassCode?.value) {
        payload.faSubClassCode = formDetails.faSubClassCode.value;
      }
      if (formDetails.depreciationBookCode?.value) {
        payload.depreciationBookCode = formDetails.depreciationBookCode.value;
      }
      if (formDetails.depreciationMethod?.value) {
        payload.depreciationMethod = formDetails.depreciationMethod.value;
      }

      if (formDetails.noOfDepreciationYear?.value) {
        payload.noOfDepreciationYear = formDetails.noOfDepreciationYear.value;
      }
      if (formDetails.faPostingGroup?.value) {
        payload.faPostingGroup = formDetails.faPostingGroup.value;
      }
    } else {
      payload.faClassCode = null;
      payload.faSubClassCode = null;
      payload.depreciationBookCode = null;
      payload.depreciationMethod = null;
      payload.noOfDepreciationYear = null;
      payload.faPostingGroup = null;
    }

    invokeApi(
      HTTP_METHODS.PUT,
      `${FINANCE_HOSTNAME}${FINANCE_REST_URLS.ITEMS}/${formDetails.id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response.message, { autoClose: 2000 });
        } else {
          setBudgetModal(false);
          loadData(filters);
          setFormDetails({});
        }
      })
      .catch((err) => {});
  };

  const onInputChange = (event) => {
    setFormDetails({
      ...formDetails,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <div className="item-list">
      <div className="itl-header-section">
        <div className="left-container">
          <TextField
            placeholder="Search"
            value={searchKey}
            size="small"
            onChange={(e) => setSearchKey(e.target.value)}
          />
          <Button
            variant="outlined"
            onClick={() =>
              loadData({
                page: 1,
                limit: 10,
              })
            }
          >
            Search
          </Button>
        </div>
        <div className="left-container">
          {isCreateAllowed("master_data") && (
            <>
              <FileUpload
                buttonBackground="#fff"
                buttonColor="#008938"
                mainButtonClass="subway-finance-bulk-upload"
                borderColor="rgba(0, 138, 82, 0.5)"
                uploadText="BULK UPLOAD"
                clsName="finance-master-data-uploader"
                url={`${FINANCE_HOSTNAME}${FINANCE_REST_URLS.UPLOAD_MASTER_DATA}item`}
                callBack={() =>
                  loadData({
                    page: filters.page,
                    limit: 10,
                  })
                }
                formDataKey="file"
              />

              <DownloadTemplateButton type={uploadTemplates.item} />
            </>
          )}

          <Button
            variant="outlined"
            disabled={!budgetList.totalResults}
            onClick={downloadData}
          >
            Download
          </Button>
          {isCreateAllowed("master_data") && (
            <>
              <Button variant="outlined" onClick={() => setBudgetModal(true)}>
                Create
              </Button>
              <Button
                variant="outlined"
                onClick={() => setFAItemsMasterModal(true)}
              >
                FA Items Master
              </Button>
            </>
          )}
        </div>
      </div>
      <MuiTable
        columnsList={getHeaderConfig(editVendor, setDeleteDetails)}
        dataList={budgetList.results || []}
        filters={filters}
        pageCount={budgetList.totalPages}
        onChange={(page) => {
          setFilters({
            ...filters,
            page,
          });
          loadData({
            ...filters,
            page,
          });
        }}
      />

      {budgetModal && (
        <CustomModal
          title={formDetails.id ? "Update Item" : "Create Item"}
          disabledOutsideClick={true}
          onClose={() => {
            setBudgetModal(false);
            setFormDetails({});
          }}
        >
          <div className="create-form">
            <TextField
              value={formDetails.name}
              onChange={onInputChange}
              size="small"
              name="name"
              label="Item Name"
              fullWidth
            />
            <TextField
              value={formDetails.hsnCode}
              onChange={onInputChange}
              size="small"
              label="HSN Code"
              name="hsnCode"
              fullWidth
            />
            <TextField
              value={formDetails.price}
              onChange={(e) => {
                if (!e.target.value) {
                  clearProperty("price", setFormDetails);
                  return;
                }
                onInputChange(e);
              }}
              size="small"
              type="number"
              label="Price"
              name="price"
              fullWidth
            />
            <TextField
              value={formDetails.taxPercentage}
              onChange={(e) => {
                if (!e.target.value) {
                  clearProperty("taxPercentage", setFormDetails);
                  return;
                }
                onInputChange(e);
              }}
              size="small"
              type="number"
              label="Tax Percentage"
              name="taxPercentage"
              fullWidth
            />

            <TextField
              value={formDetails.specification}
              onChange={onInputChange}
              size="small"
              label="Specifications"
              name="specification"
              fullWidth
            />

            <Autocomplete
              options={UOM_LIST}
              value={formDetails.uom || ""}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Unit" />
              )}
              inputValue={inputUnitValue}
              onInputChange={(event, newInputValue) => {
                if (event) {
                  setInputUnitValue(newInputValue);
                }
              }}
              onChange={(e, val) => {
                setFormDetails({
                  ...formDetails,
                  uom: val,
                });
              }}
            />

            <Autocomplete
              options={categoryList}
              value={formDetails.category || ""}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Category" />
              )}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                if (event) {
                  setInputValue(newInputValue);
                }
              }}
              onChange={(e, val) => {
                setFormDetails({
                  ...formDetails,
                  category: val,
                  subCategory: "",
                });
                if (val) {
                  loadSubcategory(val.value);
                }
                clearProperty("subCategory", setFormDetails);
                setSubCategoryInputValue("");
              }}
            />
            <Autocomplete
              options={subcategoryList}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Subcategory" />
              )}
              value={formDetails.subCategory || ""}
              inputValue={subCategoryInputValue}
              onInputChange={(event, newInputValue) => {
                if (event) {
                  setSubCategoryInputValue(newInputValue);
                }
              }}
              onChange={(e, val) => {
                setFormDetails({
                  ...formDetails,
                  subCategory: val,
                });
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formDetails.isFA}
                  onChange={handleIsFAToggle}
                  name="isFA"
                />
              }
              label="Is FA"
            />

            {formDetails.isFA && (
              <>
                <Autocomplete
                  size="small"
                  options={isFAOptions.faClassCode}
                  getOptionLabel={(option) => option.label || ""}
                  value={formDetails.faClassCode || null}
                  onChange={(e, newValue) =>
                    setFormDetails((prev) => ({
                      ...prev,
                      faClassCode: newValue,
                    }))
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="FA Class Code" />
                  )}
                />
                <Autocomplete
                  size="small"
                  options={isFAOptions.faSubClassCode}
                  getOptionLabel={(option) => option.label || ""}
                  value={formDetails.faSubClassCode || null}
                  onChange={(e, newValue) =>
                    setFormDetails((prev) => ({
                      ...prev,
                      faSubClassCode: newValue,
                    }))
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="FA Subclass Code" />
                  )}
                />
                <Autocomplete
                  size="small"
                  options={isFAOptions.depreciationBookCode}
                  getOptionLabel={(option) => option.label || ""}
                  value={formDetails.depreciationBookCode || null}
                  onChange={(e, newValue) =>
                    setFormDetails((prev) => ({
                      ...prev,
                      depreciationBookCode: newValue,
                    }))
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Depreciation Book Code" />
                  )}
                />
                <Autocomplete
                  size="small"
                  options={isFAOptions.depreciationMethod}
                  getOptionLabel={(option) => option.label || ""}
                  value={formDetails.depreciationMethod || null}
                  onChange={(e, newValue) =>
                    setFormDetails((prev) => ({
                      ...prev,
                      depreciationMethod: newValue,
                    }))
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Depreciation Method" />
                  )}
                />
                <Autocomplete
                  size="small"
                  options={isFAOptions.noOfDepreciationYear}
                  getOptionLabel={(option) => option.label || ""}
                  value={formDetails.noOfDepreciationYear || null}
                  onChange={(e, newValue) =>
                    setFormDetails((prev) => ({
                      ...prev,
                      noOfDepreciationYear: newValue,
                    }))
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="No. Of Depreciation Year" />
                  )}
                />
                <Autocomplete
                  size="small"
                  options={isFAOptions.faPostingGroup}
                  getOptionLabel={(option) => option.label || ""}
                  value={formDetails.faPostingGroup || null}
                  onChange={(e, newValue) =>
                    setFormDetails((prev) => ({
                      ...prev,
                      faPostingGroup: newValue,
                    }))
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="FA Posting Group" />
                  )}
                />
              </>
            )}

            <TextField
              value={formDetails.glCode || ""}
              onChange={onInputChange}
              size="small"
              label="GL Code"
              name="glCode"
              fullWidth
            />
            <TextField
              value={formDetails.glName || ""}
              onChange={onInputChange}
              size="small"
              label="GL Name"
              name="glName"
              fullWidth
            />

            {formDetails.id ? (
              <Button fullWidth variant="contained" onClick={onUpdate}>
                Update
              </Button>
            ) : (
              <Button fullWidth variant="contained" onClick={onSave}>
                Create
              </Button>
            )}
          </div>
        </CustomModal>
      )}
      {deleteDetails && (
        <ConfirmModal onYes={onDelete} onNo={() => setDeleteDetails(null)} />
      )}

      {priceHistoryDetails && (
        <CustomModal
          title="Price History"
          disabledOutsideClick={true}
          onClose={() => {
            setPriceHistoryDetails(null);
          }}
        >
          <PriceHistory priceHistoryDetails={priceHistoryDetails || []} />
        </CustomModal>
      )}

      {faItemsMasterModal && (
        <FAItemsMaster
          open={faItemsMasterModal}
          onClose={() => setFAItemsMasterModal(false)}
        />
      )}
    </div>
  );
};

export default ItemList;
